import React from "react";
import { createRoot } from 'react-dom/client';
import CollectionItemsBlock from '../components/CollectionItemsBlock';

const renderCollectionItems = () => {
	const itemsBlock = document.getElementById('collection-items');
	if (itemsBlock) {
		const collectionId = itemsBlock.dataset.collectionid;
		const tooltip = itemsBlock.dataset.tooltip;
		const root = createRoot(itemsBlock);
		const language = itemsBlock.dataset.lang;
		root.render(<CollectionItemsBlock collectionId={collectionId} tooltip={tooltip} language={language}/>);
	}
}

export default renderCollectionItems;